import { defineComponent as _defineComponent } from 'vue'
import { NotificationChannelEnum } from '@/@core/fire-risk-settings/domain/enums/NotificationChannel.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelsTagsDisplay',
  props: {
    channels: null
  },
  setup(__props: any) {



function getChannelTitle(channel: NotificationChannelEnum) {
	switch (channel) {
		case NotificationChannelEnum.EMAIL:
			return 'E-mail'
		case NotificationChannelEnum.WHATSAPP:
			return 'Whatsapp'
		case NotificationChannelEnum.TELEGRAM:
			return 'Telegram'
	}
}

return { __sfc: true,getChannelTitle }
}

})